import React from "react";
import { Box } from "@mui/material";
import { DotLegalButton } from "@dotlegal/dotlegal-ui-components";
import { WhiteLockIcon } from "@common/icons";
import { useTranslation } from "@localization/useTranslation";
import { useDownloadManagementReport } from "./DownloadManagementReport.hooks";
import PlanDialogButtonWrapper from "../../../plan/planDialogWrapper/planDialogWrapper";

export interface ManagementReportButtonsProps {
    reportUrl: string;
    groupName: string;
    sender: string;
    enabled: boolean;
    lockedText: string;
}

function ManagementReportButtons(props: ManagementReportButtonsProps) {
    const { translateString } = useTranslation();
    const { onDownloadManagementReport, isDownloadingManagementReport } = useDownloadManagementReport();

    const lockedToolTip = props.enabled ? undefined : props.lockedText;
    const lockIcon = props.enabled ? undefined : WhiteLockIcon;

    return (
        <Box sx={{ alignSelf: "flex-end", display: "flex", gap: 1 }}>
            <PlanDialogButtonWrapper enabled={!props.enabled} text={props.lockedText}>
                <DotLegalButton
                    ariaHaspopup
                    // The report renders as a standalone page without the navigation menu, so it opens beside the
                    // group rather than replacing it.
                    onClick={() => window.open(props.reportUrl, "_blank")}
                    buttonType={"primary"}
                    disabled={!props.enabled}
                    endIcon={lockIcon}
                    toolTip={lockedToolTip}
                >
                    {translateString("viewManagementReportInBrowser")}
                </DotLegalButton>
            </PlanDialogButtonWrapper>
            <PlanDialogButtonWrapper enabled={!props.enabled} text={props.lockedText}>
                <DotLegalButton
                    ariaHaspopup
                    onClick={() => onDownloadManagementReport(props.reportUrl, props.groupName, props.sender)}
                    isLoading={isDownloadingManagementReport}
                    buttonType={"primary"}
                    disabled={!props.enabled || isDownloadingManagementReport}
                    endIcon={lockIcon}
                    toolTip={lockedToolTip}
                >
                    {translateString("downloadManagementReport")}
                </DotLegalButton>
            </PlanDialogButtonWrapper>
        </Box>
    );
}

export default ManagementReportButtons;
